import { i18nFilter } from "app/filters/i18nFilter";
import type { ComponentProps, FC } from "react";
import UnlockModalV2Container from "../../UnlockModalContainer/UnlockModalV2Container";
import { swSettings } from "app/common/services/swSettings";
import { useTrack } from "pro-features/components/WithTrack/src/useTrack";
import LocationService from "pro-features/components/Modals/src/UnlockModal/LocationService";
import { getPackagesPageHref } from "app/UtilitiesAndConstants/UtilityFunctions/goToPackagesPage";

type UnlockModalV2ContainerProps = ComponentProps<typeof UnlockModalV2Container>;

interface IUpgradeLinkProps {
    hookType?: UnlockModalV2ContainerProps["modalConfig"]["location"];
    featureKey?: string;
}

export const UpgradeLink: FC<IUpgradeLinkProps> = ({ featureKey, hookType }) => {
    const [track] = useTrack();

    const isRedirectToNtPackagesRequired =
        swSettings.components.HookWorkspace.resources.IsRedirectOnUpgradeLinkToSubscriptionsRequired;

    if (!isRedirectToNtPackagesRequired) {
        return (
            <div className="swTable-content swTable-content--unlock">
                <UnlockModalV2Container
                    buttonText={i18nFilter()("grid.upgrade")}
                    isLink={true}
                    modalConfig={{ featureKey: featureKey || "GetMoreResults", location: hookType }}
                />
            </div>
        );
    }

    const onUpgradeClick = () => {
        track("Internal Link", "click", `UpgradeLink/${LocationService.getCurrentLocationTracking()}`);
    };

    return (
        <div className="swTable-content swTable-content--unlock">
            <a
                href={getPackagesPageHref()}
                target={"_blank"}
                rel="noreferrer"
                onClick={onUpgradeClick}
            >
                {i18nFilter()("grid.upgrade")}
            </a>
        </div>
    );
};
